import { useQuery } from "@tanstack/react-query";
import { getZoneOptions } from "services/data.internal.service";

export const useZoneOptionsQuery = ({
  queryKey = "zone-options",
  whCode,
  zoneType = "all",
  enabled,
  onSuccess,
}) => {
  let isEnabled = enabled;
  if (isEnabled === undefined) {
    isEnabled = whCode !== null;
  }
  return useQuery({
    queryKey: [queryKey, { whCode, zoneType }],
    queryFn: () => getZoneOptions({ whCode, zoneType }),
    enabled: isEnabled,
    onSuccess,
  });
};
